import Spinner from '@creator/ui/components/Spinner/Spinner';
import { useStoreState } from '@src/model/hooks';
import type { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router';

const NetworkAdminRequiredRoute: FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const isLoggedIn = useStoreState(state => state.user.isLoggedIn);
    const isAuthenticating = useStoreState(state => state.user.isAuthenticating);
    const myUser = useStoreState(state => state.user.myUser);

    const nextUrl = location.pathname + location.search;

    if (isAuthenticating === null || isAuthenticating === true) {
        return <Spinner className="mx-auto my-10 " />;
    }

    if (isAuthenticating === false && !isLoggedIn) {
        return <Navigate to={`/bbs/login?next=${encodeURIComponent(nextUrl)}`} replace />;
    }

    if (!myUser || !myUser.networkAdmin) {
        return <Navigate to="/bbs/404" replace />;
    }

    return <>{children}</>;
};

export default NetworkAdminRequiredRoute;
